import React, { useEffect, useState } from "react";
import { IconMenu2 } from "@tabler/icons-react";
import axios from "axios";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { Products } from "../../pages/home";
import { useNavigate } from "react-router-dom";
import { IconTrashFilled } from "@tabler/icons-react";
import Swal from "sweetalert2";

const DragHandle = () => {
  return (
    <span style={{ cursor: "grab" }}>
      <IconMenu2 className="mx-auto" />
    </span>
  ); // 햄버거 아이콘
};

const SortableRow = ({ product, index, total, onDelete }: any) => {
  const navigate = useNavigate();

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: product.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: isDragging ? "#f0f8ff" : "#fff",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      className=" relative w-full h-full grid grid-cols-8 gap-2 items-center text-center border-b"
    >
      <div
        className=" relative w-full h-full grid items-center py-3 pl-2"
        {...listeners}
      >
        <DragHandle />
      </div>
      {/* <p>{index + 1}</p> */}
      <div
        className="relative w-full h-full py-3 grid items-center"
        {...listeners}
      >
        <p>{product.id}</p>
      </div>
      <div
        className="col-span-2 relative w-full h-full py-3 grid items-center"
        {...listeners}
      >
        <img src={product.src} alt={`${product.title || "제품"} 썸네일`} />
      </div>
      <div
        onClick={() => navigate(`/admin/product/${product.id}`)}
        className="col-span-3 relative w-full h-full py-3 grid items-center"
      >
        <p className="relative text-ellipsis whitespace-nowrap overflow-hidden">
          {" "}
          {product.title}
        </p>
      </div>
      <div className="grid relative w-full h-full py-3 items-center pr-2">
        <IconTrashFilled
          onClick={() => onDelete(product.id)}
          className="mx-auto hover:text-black cursor-pointerrelative w-full h-full max-h-7"
        />
      </div>
    </div>
  );
};

const Dnd = ({ product }: { product: Products[] }) => {
  const [products, setProducts] = useState(product);
  const sensors = useSensors(useSensor(PointerSensor));

  useEffect(() => {
    setProducts(product);
  }, [product]);

  const handleDragEnd = async (event: { active: any; over: any }) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = products.findIndex((p) => p.id === active.id);
    const newIndex = products.findIndex((p) => p.id === over.id);
    const newOrder = arrayMove(products, oldIndex, newIndex);

    // orderId 재정렬
    const reordered = newOrder.map((item, idx) => ({
      ...item,
      orderId: idx + 1,
    }));

    setProducts(reordered);

    try {
      const payload = reordered.map(({ id, orderId }) => ({ id, orderId }));
      console.log(payload);
      await axios.patch("/api/product/reorder", payload);
    } catch (error) {
      console.error("서버 전송 오류:", error);
    }
  };

  const handleDelete = async (idToDelete: number) => {
    try {
      // 1. 서버에 삭제 요청
      await axios
        .delete(`/api/product/delete/${idToDelete}`)
        .then(async (res) => {
          // 2. 프론트에서 삭제 및 orderId 재정렬
          const updated = products
            .filter((item) => item.id !== idToDelete)
            .map((item, index) => ({ ...item, orderId: index + 1 }));

          setProducts(updated);

          // 3. 서버에 orderId 반영
          await axios
            .patch(
              "/api/product/reorder",
              updated.map(({ id, orderId }) => ({ id, orderId })),
            )
            .then((res) => {
              if (res.data.code === "0000") {
                Swal.fire({
                  title: "제품 삭제 완료",
                  text: "제품 삭제가 완료되었습니다.",
                  icon: "success",
                }).then(() => (window.location.href = "/admin/product"));
              }
            });
        });
    } catch (error) {
      console.error("삭제 오류:", error);
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={products.map((p) => p.id)}
        strategy={verticalListSortingStrategy}
      >
        <div style={{ borderCollapse: "collapse" }}>
          <div>
            <div className=" relative w-full h-full grid grid-cols-8 gap-2 text-center border-b py-3 px-2 bg-[#f9f9f9]">
              <p>이동</p>
              <p>번호</p>
              <p className="col-span-2">이미지</p>
              <p className="col-span-3">제품명</p>
              <p>삭제</p>
            </div>
          </div>
          <div>
            {products &&
              products.map((product, idx) => (
                <SortableRow
                  key={product.id}
                  product={product}
                  index={idx}
                  total={products.length}
                  onDelete={handleDelete}
                />
              ))}
          </div>
        </div>
      </SortableContext>
    </DndContext>
  );
};

export default Dnd;
